<template>
  <div class="concatUs">
    <div class="intro">
      <div class="left">
        <img class="line" src="../../assets/index/line.png" alt="" />
        <div class="title">全国门店</div>
      </div>
    </div>
    <div class="top">
      <div class="map"><img :src="`${bannerimg}`" alt="" /></div>
      <div class="text">
        <img class="line" src="../../assets/concat/wl.png" alt="" />
        <div class="title">
          阁韵在全国拥有服务商100余家 <br />
          终端用户已覆盖全国
        </div>
        <div class="subText">
          旗下建筑外窗、阳光房、幕墙 <br />
          各铝包木系列产品<br />
          可满足每一位用户的定制需求
        </div>
      </div>
    </div>

    <div style="background: #f5f5f5">
      <div class="tableWrap">
        <div class="obj">
          <div class="objIcon">
            <img src="../../assets/service/icon.png" alt="" />
          </div>
          <div class="objTitle">全国门店信息</div>
        </div>
        <div v-for="(item, index) in objlist" :key="index">
          <div class="province">{{ index }}</div>
          <div class="city" v-for="(a, b) in item" :key="b">
            <div class="name">{{ a.city }}</div>
            <div class="address">
              {{ a.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { concatStore } from "../../api/request";

export default {
  name: "Door",
  data() {
    return {
      bannerimg: null,
      // jllist: [],
      objlist: null,
    };
  },
  mounted() {
    concatStore;
    concatStore().then((res) => {
      if (res.data.code == 1) {
        this.bannerimg = res.data.data.banner;

        // console.log(res.data.data.data);
        var obj = res.data.data.data;
        this.objlist = obj;

        // for (let i in obj) {
        //   console.log(i);

        //   // this.province = i;
        //   // console.log("key:" + i + ", value:" + obj[i]);
        //   console.log(obj[i]);
        // }
      }
    });
  },
};
</script>

<style scoped lang="less">
.concatUs {
  padding-top: 60px;
  margin: 0 auto;
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    padding: 1px;
    height: 840px;
    background: #004c31;
    position: relative;
    .map {
      width: 1280px;
      height: 660px;
      position: absolute;
      top: 120px;
      left: 50%;
      margin-left: -640px;
      img {
        width: 1280px;
        height: 660px;
      }
    }
    .text {
      width: 1280px;
      margin: 60px auto 0;
      text-align: left;
      .line {
        width: 90px;
        height: 8px;
      }
      .title {
        margin: 42px 0;
        font-size: 42px;
        font-weight: bold;
        color: #ffffff;
      }
      .subText {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
  .intro {
    width: 1280px;
    margin: 0 auto 42px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #004c31;
    }
  }
  .tableWrap {
    width: 960px;
    margin: 0 auto;
    .obj {
      padding: 45px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px dotted #f5f5f5;
      .objIcon {
        width: 43px;
        height: 43px;
        img {
          width: 43px;
          height: 43px;
        }
      }
      .objTitle {
        margin-left: 17px;
        font-size: 32px;
        font-weight: 400;
        color: #004c31;
      }
    }
    .province {
      padding: 0 24px;
      height: 60px;
      background: #004c31;
      font-size: 20px;
      color: #ffffff;
      line-height: 60px;
      text-align: left;
    }
    .city {
      height: 60px;
      border-bottom: 2px solid #f5f5f5;
      background: #ffffff;
      display: flex;
      align-items: center;
      .name {
        width: 198px;
        text-align: left;
        padding-left: 24px;
        height: 60px;
        color: #000;
        line-height: 60px;
      }
      .address {
        width: 740px;
        text-align: left;
        padding-left: 24px;
        height: 60px;
        color: #6c7a77;
        line-height: 60px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .concatUs {
    padding-top: 60px;
    margin: 0 auto;
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      padding: 1px;
      height: 840 * 2px;
      background: #004c31;
      position: relative;
      .map {
        width: 1280px;
        height: 660px;
        position: absolute;
        top: 120 * 7px;
        left: 50%;
        margin-left: -640px;
        img {
          width: 1280px;
          height: 660px;
        }
      }
      .text {
        width: 1280px;
        margin: 60px auto 0;
        text-align: left;
        .line {
          width: 90 * 2px;
          height: 8 * 2px;
        }
        .title {
          margin: 42px 0;
          font-size: 42 * 2px;
          font-weight: bold;
          color: #ffffff;
        }
        .subText {
          font-size: 20 * 2px;
          color: #ffffff;
        }
      }
    }
    .intro {
      width: 1280px;
      margin: 0 auto 42px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-weight: 400;
        color: #004c31;
      }
    }
    .tableWrap {
      width: auto;
      margin-left: 0px;
      .obj {
        padding: 45px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px dotted #f5f5f5;
        .objIcon {
          width: 43 * 2px;
          height: 43 * 2px;
          img {
            width: 43 * 2px;
            height: 43 * 2px;
          }
        }
        .objTitle {
          margin-left: 17px;
          font-size: 32px;
          font-weight: 400;
          color: #004c31;
        }
      }
      .province {
        padding: 0 24px;
        height: 60 * 4px;
        background: #004c31;
        font-size: 20 * 4px;
        color: #ffffff;
        line-height: 60 * 4px;
        text-align: left;
      }
      .city {
        height: 60 * 4px;
        border-bottom: 2px solid #f5f5f5;
        background: #ffffff;
        display: flex;
        align-items: center;
        .name {
          width: 198 * 4px;
          text-align: left;
          padding-left: 24px;
          font-size: 48px;
          height: auto;
          color: #000;
          line-height: unset;
        }
        .address {
          font-size: 48px;
          width: 740 * 4px;
          text-align: left;
          padding-left: 24px;
          height: 60 * 4px;
          color: #6c7a77;
          display: flex;
          align-items: center;
          line-height: unset;
        }
      }
    }
  }
}
</style>
